import { FormFeedback, STATUS_TYPE } from "taltech-styleguide";
import { useField } from "formik";

export const FeedbackMessage = (props: { fieldId: string }) => {
  const [field, meta, helpers] = useField(props.fieldId);
  const hasError = meta.touched && meta.error;
  if (hasError) {
    return <FormFeedback type={STATUS_TYPE.DANGER}>{meta.error}</FormFeedback>;
  }
  return <></>;
};
